<template>
  <div
    class="modal-wrapper"
    v-show="showModal"
    ref="modalDom">
    <div
      class="overlay"
      v-if="needModal"
      :style="modalStyle"
      @click="hideMask" />
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    needModal: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    modalStyle: {
      type: Object,
      default: () => { }
    }
  },
  mounted () {
    if (this.lockScroll) {
      this.preventScroll()
    }
  },
  methods: {
    preventScroll () {
      const modalDom = this.$refs.modalDom
      modalDom &&
        modalDom.addEventListener('touchmove', (event) => {
          event.preventDefault()
          event.stopPropagation()
        })
    },
    hideMask () {
      this.$emit('modalClick')
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  .overlay {
    width: 100%;
    height: 100%;
    background: $color-bg-black;
    opacity: 0.48;
  }
}
</style>
